import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Button, Row, Col, Progress, Tooltip, Empty, Skeleton } from 'antd';
import BubbleChat from '../../D3Charts/BubbleChat';
import InsightList from './InsightList';
import styles from './Insight.module.scss';
import { EmptyIndustriesIcon } from '../../../Icons/AryaIcons';
import { menuItemsList } from '../../../Utils/GlobalInsightSupplyUtil';
import eventTypes from '../../../Analytics/EventTypes';
import jobMessage from '../../JobForm/JobMessages';

const chartConfig = {
  width: 700,
  height: 350,
  padding: 10,
  backgroundColor: '#FFFFFF',
  strokeWidth: '3px',
  stroke: '#13C26B',
  bubbleChartDataValueClass: styles.bubbleChartDataValue,
};
export default function IndustryInsightView(props) {
  const { listOfIndustriesStats, loading, readonlyStats, emptyInsightDescription } = props;
  const [industryListView, setIndustryListView] = React.useState(false);
  React.useEffect(() => {
    if (industryListView) {
      setIndustryListView(false);
    }
  }, [loading]);

  const industryInsightTitle = (
    <div className={styles.headerTitle}>
      <FormattedMessage {...jobMessage.industryLabel} />
    </div>
  );
  const industryInsightDescription = (
    <div className={styles.headerDescription}>
      <FormattedMessage {...jobMessage.industryInsightDescriptionLabel} />
    </div>
  );

  return (
    <div className={styles.supplyContent} id={menuItemsList.industries.id}>
      {industryListView ? (
        <>
          <div className={styles.headerSupplyInfo} id="IndustryListHeader">
            <div className={styles.headerInfo}>
              {industryInsightTitle}
              <div className={styles.headerButton}>
                <Button
                  size="small"
                  onClick={() => setIndustryListView(false)}
                  sk-event-name={eventTypes.job.marketIntel.hideIndustryList}
                >
                  X
                </Button>
              </div>
            </div>
            {industryInsightDescription}
          </div>
          <div id="IndustriesList">
            <InsightList insightList={listOfIndustriesStats} loading={loading} itemSpan={11} />
          </div>
        </>
      ) : (
        <>
          <div className={styles.headerSupplyInfo}>
            <div className={styles.headerInfo}>
              {industryInsightTitle}
              <div className={styles.headerButton}>
                <Button
                  size="small"
                  disabled={listOfIndustriesStats.length < 1}
                  onClick={() => setIndustryListView(true)}
                  sk-event-name={eventTypes.job.marketIntel.displayIndustryList}
                >
                  <FormattedMessage {...jobMessage.seeListLabel} />
                </Button>
              </div>
            </div>
            {industryInsightDescription}
          </div>
          <div>
            <Skeleton active paragraph={{ rows: 5 }} loading={loading}>
              <Row>
                {listOfIndustriesStats.length > 0 ? (
                  <>
                    <div className={styles.listTitle}>
                      <FormattedMessage {...jobMessage.topFiveIndustriesLabel} />
                    </div>
                    <Col span={10} id="TopIndustries">
                      {listOfIndustriesStats.slice(0, 5).map(item => (
                        <div className={styles.supplyTopListView} key={item.DisplayName}>
                          <div className={styles.supplyName}>
                            <Tooltip title={item.DisplayName}>{item.DisplayName}</Tooltip>
                          </div>
                          <Progress percent={item.SupplyPercentage} size="small" />
                        </div>
                      ))}
                    </Col>
                    <Col span={14}>
                      <div className={styles.bubbleCharts}>
                        <BubbleChat list={listOfIndustriesStats.slice(0, 5)} chartConfig={chartConfig} />
                      </div>
                    </Col>
                  </>
                ) : (
                  <div>
                    <Empty
                      image={<EmptyIndustriesIcon className={styles.emptyIcon} />}
                      description={
                        <div>
                          <h3>
                            <FormattedMessage {...jobMessage.noIndustryDateFoundLabel} />
                          </h3>
                          {!readonlyStats ? <div>{emptyInsightDescription}</div> : null}
                        </div>
                      }
                    />
                  </div>
                )}
              </Row>
            </Skeleton>
          </div>
        </>
      )}
    </div>
  );
}
